import { X, CreditCard } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const PaymentMethodModal = () => {
  const {
    showPmModal,
    setShowPmModal,
    isUpdatingPaymentMethod,
    handleUpdatePaymentMethod
  } = useProfile();

  if (!showPmModal) return null;

  return (
    <div
      className="fixed inset-0 z-[99999] bg-black/50 backdrop-blur-xs flex items-center justify-center p-4 overflow-y-auto"
      onWheel={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
    >
      <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-2xl animate-modal-entry">
        <div className="p-6 pb-4 flex justify-between items-start">
          <h2 className="font-bold text-lg text-slate-900">Update payment method</h2>
          <button onClick={() => setShowPmModal(false)} className="p-1 hover:bg-slate-100 rounded-lg text-slate-400 cursor-pointer">
            <X size={18} />
          </button>
        </div>
        <div className="p-6 pt-0 space-y-4">
          <p className="text-xs text-slate-600 leading-relaxed">
            You will be redirected to Razorpay to complete authentication of a new card or UPI Autopay mandate. Trrip never stores your financial info. Next billing cycle auto debits will reflect the new method.
          </p>
          <div className="flex gap-3 justify-end pt-2">
            <button
              onClick={() => setShowPmModal(false)}
              disabled={isUpdatingPaymentMethod}
              className="px-4 py-2 border border-slate-200 hover:bg-slate-50 text-xs font-bold text-slate-600 rounded-xl cursor-pointer"
            >
              Cancel
            </button>
            <button
              onClick={handleUpdatePaymentMethod}
              disabled={isUpdatingPaymentMethod}
              className="px-4 py-2 bg-[#067978] hover:bg-[#05605f] text-white text-xs font-bold rounded-xl flex items-center gap-1.5 cursor-pointer shadow-md shadow-[#067978]/20 disabled:opacity-60"
            >
              {isUpdatingPaymentMethod ? (
                <span className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <>
                  <CreditCard size={14} /> Continue on Razorpay
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodModal;
